<template>
  <data-loader>
    <page-layout
      class="simulation-intro"
      data-test="simulation-intro"
    >
      <template #header>
        <simulation-header :title="simulation.name"></simulation-header>
      </template>
      <div
        class="simulation-page-content"
        v-html="html"
      >
      </div>
      <agree-pill
        v-if="requiresAgreement"
        @agree-checked="agreeChecked = true"
        @agree-unchecked="agreeChecked = false"
      ></agree-pill>
      <template #footer>
        <page-footer
          :button-text="isLastPage ? 'Start' : 'Next'"
          :requires-agreement="requiresAgreement"
          :agree-checked="agreeChecked"
          @next-button-clicked="nextPage"
        >
          <template
            v-if="startError"
            #left-buttons
          >
            <span
              class="start-error"
              data-test="start-error"
            >{{ startError }}</span>
          </template>
        </page-footer>
      </template>
    </page-layout>
  </data-loader>
</template>

<script>
import WuxSimulationsMixin from '@/mixins/wux-simulations';
import PageLayout from '@components/sims/single-section-sim/PageLayout.vue';
import SimulationHeader from '@components/sims/single-section-sim/SimulationHeader.vue';
import AgreePill from '@components/sims/single-section-sim/AgreePill.vue';
import PageFooter from '@components/sims/single-section-sim/PageFooter.vue';
import DataLoader from '@/components/sims/DataLoader.vue';

export default {
  components: {
    AgreePill,
    PageLayout,
    PageFooter,
    SimulationHeader,
    DataLoader,
  },
  mixins: [WuxSimulationsMixin],
  data: () => ({
    agreeChecked: false,
    startError: null,
  }),
  computed: {
    pageNum() {
      return +this.$route?.params['pageNum'];
    },
    pages() {
      return this.simulation.introText?.split('<!-- page break -->') || ['Intro text is not found. It can be edited, by editing this category in the CMS.'];
    },
    html() {
      return this.pages[this.pageNum - 1];
    },
    isLastPage() {
      return this.pageNum === this.pages.length;
    },
    requiresAgreement() {
      return this.html?.toLowerCase().includes('i agree');
    },
  },
  methods: {
    nextPage() {
      if (this.isLastPage && this.isAdaptiveSimulation) {
        return this.startAdaptiveSimulation();
      }
      if (this.isLastPage) {
        return this.setCategoryState(this.simulation, this.inProgressStatus).then(() => {
          return this.$router.push({
            name: 'simFlashcard#show',
            params: {
              simId: this.simulation.id,
              flashcardId: this.flashcardStatesOrdered[0].flashcardId,
            },
          });
        });
      }
      return this.$router.push({
        name: 'sims#intro',
        params: {
          simId: this.simulation.id,
          pageNum: this.pageNum + 1,
        },
      });
    },
    startAdaptiveSimulation() {
      this.startError = null;
      return this.$store.dispatch('adaptiveSim/start', this.simId).then(({ catSession }) => {
        if (catSession.status !== 'in_progress') {
          return this.$router.push({ name: 'adaptiveSim#result', params: { simId: this.simId, sessionId: catSession.id } });
        }
        this.startSimulation(this.simulation.name, this.simId);
        return this.$router.push({ name: 'adaptiveSim#show', params: { simId: this.simId, sessionId: catSession.id } });
      }).catch(error => {
        console.error(error);
        this.startError = error.response?.data?.error || 'The simulation could not be started. Please try again.';
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.start-error {
  color: white;
  font-size: 1rem;
}

.simulation-intro {
  .simulation-page-content {
    font-size: 1.25rem;
    padding: 1.25rem;

    h1, h2, h3, h4, h5, h6 {
      font-size: 1.25rem;
    }
  }
}
</style>
